export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "PU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "NU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "NU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "ZU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "ZU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "PU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "NU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "NU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "ZU",
	},
	pikachu: {
		tier: "LC",
	},
	raichu: {
		tier: "UU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "ZU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "ZU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "PU",
	},
	clefairy: {
		tier: "LC",
	},
	clefable: {
		tier: "UU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "UU",
	},
	jigglypuff: {
		tier: "LC",
	},
	wigglytuff: {
		tier: "ZU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "ZU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "ZU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "ZU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "NU",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		tier: "UU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "UU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "PU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "PU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "NU",
	},
	poliwag: {
		tier: "ZUBL",
	},
	poliwhirl: {
		tier: "NU",
	},
	poliwrath: {
		tier: "NU",
	},
	abra: {
		tier: "PU",
	},
	kadabra: {
		tier: "NU",
	},
	alakazam: {
		tier: "OU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "ZU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "NU",
	},
	tentacool: {
		tier: "ZU",
	},
	tentacruel: {
		tier: "NU",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "PU",
	},
	golem: {
		tier: "NU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "UU",
	},
	slowpoke: {
		tier: "ZU",
	},
	slowbro: {
		tier: "UU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "NU",
	},
	farfetchd: {
		tier: "ZU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "UU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "NU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "ZU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "OU",
	},
	gastly: {
		tier: "PU",
	},
	haunter: {
		tier: "UU",
	},
	gengar: {
		tier: "OU",
	},
	onix: {
		tier: "ZU",
	},
	drowzee: {
		tier: "ZU",
	},
	hypno: {
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "ZU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "NU",
	},
	exeggcute: {
		tier: "PU",
	},
	exeggutor: {
		tier: "OU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "ZU",
	},
	hitmonlee: {
		tier: "ZU",
	},
	hitmonchan: {
		tier: "ZU",
	},
	lickitung: {
		tier: "ZU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "ZU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "OU",
	},
	chansey: {
		tier: "OU",
	},
	tangela: {
		tier: "NU",
	},
	kangaskhan: {
		tier: "UU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "PU",
	},
	staryu: {
		tier: "PU",
	},
	starmie: {
		tier: "OU",
	},
	mrmime: {
		tier: "NU",
	},
	scyther: {
		tier: "PU",
	},
	jynx: {
		tier: "OU",
	},
	electabuzz: {
		tier: "UU",
	},
	magmar: {
		tier: "PU",
	},
	pinsir: {
		tier: "ZU",
	},
	tauros: {
		tier: "OU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
	},
	lapras: {
		tier: "UU",
	},
	ditto: {
		tier: "ZU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "NU",
	},
	jolteon: {
		tier: "UU",
	},
	flareon: {
		tier: "ZU",
	},
	porygon: {
		tier: "PU",
	},
	omanyte: {
		tier: "ZU",
	},
	omastar: {
		tier: "NU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "NU",
	},
	aerodactyl: {
		tier: "NU",
	},
	snorlax: {
		tier: "OU",
	},
	articuno: {
		tier: "UU",
	},
	zapdos: {
		tier: "OU",
	},
	moltres: {
		tier: "UU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "ZU",
	},
	dragonite: {
		tier: "UU",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Uber",
	},
	missingno: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
};
